import { createContext } from "react";

export interface PermissionContextValue {
  can: (permission?: string) => boolean;
  permissionCodes: string[];
}

export const PermissionContext = createContext<PermissionContextValue>({
  can: () => false,
  permissionCodes: [],
});
